<div class="user-item">
  <div class="user-info">
    <div class="avatar-block">
      @if (user()?.['avatar_config']?.type === 'avatar') {
        <div class="avatar-src" [style.background-image]="'url(' + user()['avatar_config']?.src + ')'"></div>
      } @else {
        <div class="avatar-src" [ngStyle]="{'background-color': user()?.['avatar_config']?.src || '#ccc'}">
          {{ nameFirstLetter() }}
        </div>
      }
      <div class="user-details">
        <div class="username semibold-16">{{ user().username }}</div>
        @if (user().email) {
          <div class="email regular-12">{{ user().email }}</div>
        }
      </div>
    </div>

    @if (user().leveling?.level !== undefined && user().leveling?.level >= 0) {
      <div class="level bold-12">{{ user().leveling.level }} {{ 'level' | transloco }}</div>
    }
  </div>

  <ng-content select="[actions]"></ng-content>
</div>

